import React from "react";
import logo from '../../assets/images/logo_branca_passarela_44.png';

const DEFAULT_HEADER_BG_COLOR = '#E2725B';

const buildDefaultMenuItems = ({ sobre, tecnologias, facaParte }) => ([
    { label: 'Home', href: '#hero' },
    { label: 'Sobre Nós', href: sobre },
    { label: 'Tecnologias', href: tecnologias },
    { label: 'Seja Nosso Parceiro', href: facaParte },
    { label: 'Área do Lojista', href: '/dashboard', className: 'btn-lojista' }
]);

const HeaderWebPage = ({ sobre, tecnologias, facaParte, menuItems, headerBgColor = DEFAULT_HEADER_BG_COLOR }) => {
    const items = Array.isArray(menuItems) && menuItems.length > 0
        ? menuItems
        : buildDefaultMenuItems({ sobre, tecnologias, facaParte });

    const headerStyle = {
        '--header-bg-color': headerBgColor || DEFAULT_HEADER_BG_COLOR,
    };

    return (
        <header style={headerStyle}>
            <div className="header-content">
                {/* Logo alinhada à esquerda */}
                <a href='/'>
                    <div className="logo">
                        <img src={logo} alt="Logo Passarela 44" />
                    </div>
                </a>

                {/* Input invisível para controlar o menu mobile via CSS */}
                <input type="checkbox" id="menu-toggle" className="menu-toggle" />

                {/* Ícone de barrinhas (Hambúrguer) */}
                <label htmlFor="menu-toggle" className="hamburger">
                    <span></span>
                    <span></span>
                    <span></span>
                </label>

                {/* Navegação */}
                <nav className="nav-menu">
                    {items
                        .filter((item) => item && item.label && item.href)
                        .map((item, index) => (
                            <a key={`${item.label}-${index}`} href={item.href} className={item.className || ''}>
                                {item.label}
                            </a>
                        ))}
                </nav>
            </div>
        </header>
    )
};

export default HeaderWebPage;